import {
  SettingsFormControl,
  TextInputField
} from '@sequencehq/core-components'

import { Merchant, useMerchantSettings } from './useMerchantSettings'

export const MerchantSettings = (props: { merchant: Merchant }) => {
  const { getInputFieldProps } = useMerchantSettings(props.merchant)

  return (
    <>
      <SettingsFormControl
        label="Company name"
        helper="The company name you want to appear on the invoice"
        htmlFor="company-name"
      >
        <TextInputField
          {...getInputFieldProps('legalCompanyName', {
            label: 'Company name',
            id: 'company-name',
            placeholder: 'Acme, inc.'
          })}
        />
      </SettingsFormControl>

      <SettingsFormControl label="Company email" htmlFor="company-email">
        <TextInputField
          type="email"
          {...getInputFieldProps('email', {
            placeholder: 'hello@example.com',
            id: 'company-email',
            label: 'Company email'
          })}
        />
      </SettingsFormControl>

      <SettingsFormControl label="URL" htmlFor="company-url">
        <TextInputField
          {...getInputFieldProps('appUrl', {
            placeholder: 'https://',
            id: 'company-url',
            label: 'Company URL'
          })}
        />
      </SettingsFormControl>
    </>
  )
}
